import { utils } from 'ethers';
import { LogDescription } from 'ethers/lib/utils.js';

export const getOpenPositionId = (logs: LogDescription[]) => {
  if (!logs.length) return;
  const abi = [
    'event PositionCreated(address indexed _from, uint256 indexed _positionId, uint256 _princple, uint256 _levTaken, uint256 _archBurned, uint256 _positionExp)',
  ];
  const iface = new utils.Interface(abi);
  const decodedLogs = logs.map((log: any) => {
    try {
      return iface.decodeEventLog('PositionCreated', log.data, log.topics);
    } catch (err) {
      return undefined;
    }
  });
  if (!decodedLogs.length) return;
  let positionId;
  decodedLogs.forEach((log: any) => {
    if (log && log._positionId) {
      positionId = log._positionId.toNumber();
    }
  });
  // console.log({ positionId });
  if (typeof positionId === 'number') return positionId;
};
